import { compose } from "redux";

import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import RegisterIcon from "@material-ui/icons/BorderColor";
import ConfirmIcon from "@material-ui/icons/DoneAll";
import ImportIcon from "@material-ui/icons/AssignmentReturn";

import RetractableSidebar, {
  activeStyle,
} from "../../home/components/Retractable.Sidebar";

import Link from "admin/shared/ui/Link.Component";

import { reportsConnector } from "../../../services/reports/connector";

const ReportsComponent = ({ children }) => {
  let wrapperStyle = {
    display: "flex",
    minHeight: "100%",
  };

  return (
    <div className="reports-layout" style={wrapperStyle}>
      <RetractableSidebar storageKey="reports">
        <List>
          <ListItem disabled={true}>
            <ListItemIcon>
              <div />
            </ListItemIcon>
            <ListItemText primary="Reports:" />
          </ListItem>
          <Link
            activeClassName={"selected"}
            activeStyle={activeStyle}
            toState={"ucReports"}
          >
            <ListItem button>
              <ListItemIcon>
                <RegisterIcon />
              </ListItemIcon>
              <ListItemText primary="UC reports" />
            </ListItem>
          </Link>
          <Link
            activeClassName={"selected"}
            activeStyle={activeStyle}
            toState={"crmReports"}
          >
            <ListItem button>
              <ListItemIcon>
                <ConfirmIcon />
              </ListItemIcon>
              <ListItemText primary="CRM email reports" />
            </ListItem>
          </Link>
          <Link
            activeClassName={"selected"}
            activeStyle={activeStyle}
            toState={"taxReports"}
          >
            <ListItem button>
              <ListItemIcon>
                <ImportIcon />
              </ListItemIcon>
              <ListItemText primary="Tax reports" />
            </ListItem>
          </Link>
          <Link
            activeClassName={"selected"}
            activeStyle={activeStyle}
            toState={"monthlyReports"}
          >
            <ListItem button>
              <ListItemIcon>
                <ImportIcon />
              </ListItemIcon>
              <ListItemText primary="Monthly reports" />
            </ListItem>
          </Link>
          <Link
            activeClassName={"selected"}
            activeStyle={activeStyle}
            toState={"borrowerSurplus"}
          >
            <ListItem button>
              <ListItemIcon>
                <RegisterIcon />
              </ListItemIcon>
              <ListItemText primary="Borrower surplus" />
            </ListItem>
          </Link>
        </List>
      </RetractableSidebar>
      <div
        style={{
          width: "100%",
          boxSizing: "border-box",
          overflow: "auto",
          backgroundColor: "#f9f9f9",
        }}
      >
        <div className="body-height content-padding">{children}</div>
      </div>
    </div>
  );
};
export default compose(reportsConnector)(ReportsComponent);
